import {
    MediaProgramGuide,
    WorkflowStepDataPoll,
    WorkflowStepInfo,
} from '@calm/evexia-web-sdk';
import { NextButtonOnClickHandler } from '@rhg/components/program/next-button/types';
import { POLL_ID } from '@rhg/constants';
import { useGuidePlayer } from '@rhg/hooks/use-guide-player';
import { useProvidedProgramContext } from '@rhg/hooks/use-provided-program-context';
import { OpenGuidePlayerProps } from '@rhg/providers/guide-player/types';
import { routes } from '@rhg/utils/routes';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export function useProgramActions() {
    const { push } = useRouter();
    const { program, packClass, workflow, toolsByGuide } =
        useProvidedProgramContext();
    const { openGuidePlayer } = useGuidePlayer();

    const playGuide = useCallback(
        (
            guide: MediaProgramGuide,
            openGuidePlayerProps: Partial<OpenGuidePlayerProps> = {}
        ) => {
            openGuidePlayer({
                guide,
                program: program!,
                packClass: packClass!,
                workflow,
                tools: toolsByGuide[guide.id],
                willSkipToPreviousProgress: true,
                ...openGuidePlayerProps,
            });
        },
        [openGuidePlayer, packClass, program, toolsByGuide, workflow]
    );

    const handleWorkflowStep = useCallback(
        (step: WorkflowStepInfo) => {
            if (step?.stepDefn?.type === 'poll') {
                const pollData = step?.stepDefn?.data as WorkflowStepDataPoll;
                if (pollData?.relatedId === POLL_ID.MENTAL_HEALTH) {
                    push(
                        routes.screening({ packClass, programId: program?.id })
                    );
                }
            } else {
                alert(`todo handling workflow step ${step?.stepDefn?.defnId}`);
            }
        },
        [packClass, program?.id, push]
    );

    const handleNextButton = useCallback<
        (
            callback?: NextButtonOnClickHandler,
            openGuidePlayerProps?: Partial<OpenGuidePlayerProps>
        ) => NextButtonOnClickHandler
    >(
        (callback, openGuidePlayerProps) => (handledItem) => {
            callback?.(handledItem);
            if (handledItem.type === 'guide' && handledItem?.guide) {
                playGuide(handledItem.guide, openGuidePlayerProps);
            } else if (
                handledItem.type === 'workflowStep' &&
                handledItem?.step
            ) {
                handleWorkflowStep(handledItem.step);
            }
        },
        [handleWorkflowStep, playGuide]
    );

    return { handleNextButton, playGuide, handleWorkflowStep };
}
